import LogoGraySpinner from './LogoGraySpinner';

const FullpageAnimatedLogo = () => {
  return (
    <>
      <style>{'body{overflow:hidden}'}</style>
      <div className='bg-body fixed z-50 flex h-[calc(100svh-80px)] w-full items-center justify-center overflow-hidden rounded-md'>
        <LogoGraySpinner className='h-32 w-32' />
      </div>
    </>
  );
};

export default FullpageAnimatedLogo;
